"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$postBookmark = exports.$getBookmarks = exports.$deleteBookmark = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var base = '/bookmarks';
var $getBookmarks = filter => (0, _oldHttpClient.getAxiosProvider)()({
  method: 'get',
  url: "".concat(base, "/"),
  params: {
    type: filter
  }
});
exports.$getBookmarks = $getBookmarks;
var $postBookmark = bookmark => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/"),
  body: bookmark
});
exports.$postBookmark = $postBookmark;
var $deleteBookmark = id => (0, _oldHttpClient.apiClient)({
  method: 'delete',
  url: "".concat(base, "/").concat(id)
});
exports.$deleteBookmark = $deleteBookmark;